/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, replacePXinStringWithEM, disable, convertHexToRGB } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../../../utils/styles/general';



/* ++++++++++ --------------- MENU ITEM : STYLES --------------- ++++++++++ */
export default {
	menuitem: {
		cursor: 'pointer',
		width: '100%',
		padding: replacePXinStringWithEM('0px 20px 20px'),
		display: 'flex',
		alignItems: 'center',
		extend: hoverTransition(),
		color: themeV2.color.base.gray.dark,
		'& .icon': {
			color: themeV2.color.base.gray.dark,
			fontSize: pxToEm(14),
			width: pxToEm(20),
			marginRight: pxToEm(16),
			extend: hoverTransition()
		},
		'& .text': {
			color: themeV2.color.base.gray.dark,
			fontSize: pxToEm(14),
			extend: hoverTransition()
		},
		'&:hover': {
			'& .icon': {
				color: themeV2.color.primary.main
			},
			'& .text': {
				color: themeV2.color.primary.main
			}
		},
		'&:first-child': {
			paddingTop: pxToEm(20)
		},
		'&.isDisabled': {
			'&-true': {
        extend: disable,
        color: themeV2.color.base.disabled,
        filter: 'none',
        opacity: 1,
        '& .text, & .icon': {
          color: `${themeV2.color.base.disabled} !important`
        }
			}
		},
		'&.isActive': {
			'&-true': {
				'& .text, & .icon': {
					color: themeV2.color.primary.main
				}
			}
		}
	}
}; 